import { Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import dayjs from 'dayjs'

/**
 * Validates if a file was created/modified within the allowed time window
 * @param file - The file to validate
 * @param maxAgeHours - Maximum age in hours (if undefined, validation is skipped)
 * @returns Promise<true> if valid/skipped/user confirmed, Promise<false> if user rejected
 */
export async function validateFileAge(
  file: File,
  maxAgeHours?: number,
): Promise<boolean> {
  // Skip validation if maxAgeHours is not provided
  if (maxAgeHours === undefined) {
    return true
  }

  const photoTimestamp = dayjs(file.lastModified)
  const hoursAgo = dayjs().diff(photoTimestamp, 'hour', true)

  if (hoursAgo > maxAgeHours) {
    const isImage = file.type.startsWith('image/')
    const label = isImage ? 'Kuva' : 'Tiedosto'
    return new Promise((resolve) => {
      modals.openConfirmModal({
        title: `${label} on liian vanha`,
        centered: true,
        children: (
          <Text>
            {label} on otettu yli {maxAgeHours} tuntia sitten. Haluatko käyttää
            sitä silti?
          </Text>
        ),
        labels: { confirm: 'Käytä', cancel: 'Peruuta' },
        confirmProps: { color: 'yellow' },
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
      })
    })
  }

  return true
}
